import React from 'react';

const BasicExperience = () => {
    return (
        <div style={{width: "100%", "padding-top": "6.5em"}}>
            <div style={{position: "relative", "padding-bottom": "56.25%", "padding-top": 0, height: 0}}>
                <iframe frameBorder="0" width="1920" height="1080" style={{position: "absolute", top: 0, left: 0, width: "100%", height: "100%"}} 
                    src="https://view.genial.ly/62b0f1a1db4b5400114d715e" type="text/html" allowscriptaccess="always" allowFullScreen={true} 
                    scrolling="yes" allownetworking="all">
                </iframe> 
            </div> 
        </div>
    );
}

export default BasicExperience;